/**
 * pages/index.js --- Entry point for landing page
 *
 * This page is basically an alias to the most recent
 * issue of the archive. It just points to the latest
 * archive issue from index.html
 */

import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import SEO from "../components/seo"

import Layout from "../components/layout"

/**
 * IndexPage (default): Entry point component
 */
const IndexPage = props => {
  /**
   * Alias query that grabs the most recent issue number
   * by default to render onto the landing URL.
   */
  useStaticQuery(graphql`
    # Write your query or mutation here
    query {
      allContentfulIssue(sort: { fields: slug, order: DESC }) {
        edges {
          node {
            title
            slug
            editorialTitle
            color
            date(formatString: "MMMM Do, YYYY")
            articles {
              title
              slug
              author
              color
              navImage {
                file {
                  url
                }
              }
            }
            dropcap
            editorial {
              json
            }
            signature {
              json
            }
          }
        }
      }
    }
  `)

  // TODO 9: Custom SEO for articles
  return (
    <>
      <SEO title="Wet Ink Archive" />
      <Layout
        issue={props.data.allContentfulIssue.edges[0].node}
        archiveMenuData={props.data.allContentfulIssue}
      />
    </>
  )
}

export default IndexPage
